import { TrackJS } from 'trackjs';

export function trackJs(err: any) {
  if (typeof window !== 'undefined') {
    TrackJS.track(err);
  }
}
